/* Paola Milano cart drawer — v2: verzekerde verzending + "nog een paar"-aanbod (geen aanbevolen producten meer). */
(function () {
  const TIMER_KEY = 'pm_cart_timer_start';
  const TRASH_ICON = '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M8 3.5a.5.5 0 0 0-.5.5v.5h5V4a.5.5 0 0 0-.5-.5H8Zm5.5 1V4A1.5 1.5 0 0 0 12 2.5H8A1.5 1.5 0 0 0 6.5 4v.5H4a.5.5 0 0 0 0 1h.54l.8 10.4A1.75 1.75 0 0 0 7.08 17.5h5.84a1.75 1.75 0 0 0 1.74-1.6l.8-10.4H16a.5.5 0 0 0 0-1h-2.5Zm.8 1H5.7l.79 10.33a.75.75 0 0 0 .74.67h5.84a.75.75 0 0 0 .75-.67L14.3 5.5ZM8.5 7.5A.5.5 0 0 1 9 8v6a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5Zm3 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5Z"/></svg>';
  const TAG_ICON = '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M11.5 3a1.5 1.5 0 0 0-1.06.44l-6 6a1.5 1.5 0 0 0 0 2.12l4 4a1.5 1.5 0 0 0 2.12 0l6-6A1.5 1.5 0 0 0 17 8.5v-4A1.5 1.5 0 0 0 15.5 3h-4Zm2.5 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/></svg>';
  const SHOE_SIZE = /^(3[4-9]|4[0-7])([.,]5)?$/;
  const SIZE_NAME = /taglia|size|numero|misur|dimension/i;

  class PmCartDrawer {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-pm-cart-config]').textContent);
      this.text = this.config.text;
      this.panel = root.querySelector('.pm-cart__panel');
      this.title = root.querySelector('[data-pm-cart-title]');
      this.timer = root.querySelector('[data-pm-cart-timer]');
      this.itemsList = root.querySelector('[data-pm-cart-items]');
      this.empty = root.querySelector('[data-pm-cart-empty]');
      this.offer = root.querySelector('[data-pm-cart-offer]');
      this.footer = root.querySelector('[data-pm-cart-footer]');
      this.protection = root.querySelector('[data-pm-protection]');
      this.protectionInput = root.querySelector('[data-pm-protection-input]');
      this.summary = root.querySelector('[data-pm-cart-summary]');
      this.discountTags = root.querySelector('[data-pm-cart-discount-tags]');
      this.discountTotal = root.querySelector('[data-pm-cart-discount-total]');

      this.protectionId = Number(this.config.protection?.variantId || 0);
      this.compareAt = new Map(Object.entries(this.config.compareAtPrices || {}).map(([id, price]) => [Number(id), Number(price)]));
      this.productCache = new Map();
      this.cart = null;
      this.pending = new Set();
      this.busy = false;
      this.lastFocus = null;
      this.timerInterval = null;

      // Zelfde plek als UpCart: bovenaan de body, boven de header.
      document.body.prepend(root);

      this.bind();
      this.interceptAddToCart();
      this.startTimer();
      this.refresh();

      window.PmCart = {
        open: () => this.refresh().then(() => this.open()),
        close: () => this.close(),
        refresh: () => this.refresh()
      };
    }

    get routeRoot() {
      return window.Shopify?.routes?.root || this.config.root || '/';
    }

    isProtection(item) {
      return this.protectionId && Number(item.variant_id) === this.protectionId;
    }

    productItems(cart) {
      return (cart.items || []).filter((item) => !this.isProtection(item));
    }

    bind() {
      document.querySelectorAll('[data-cart-toggle]').forEach((trigger) => {
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.lastFocus = trigger;
          this.open();
          this.refresh();
        });
      });

      this.root.querySelectorAll('[data-pm-cart-close]').forEach((node) => {
        node.addEventListener('click', () => this.close());
      });

      document.addEventListener('keydown', (event) => {
        if (!this.isOpen()) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'Tab') this.trapFocus(event);
      });

      document.addEventListener('submit', (event) => this.handleProductForm(event));

      this.itemsList.addEventListener('click', (event) => {
        const item = event.target.closest('[data-line-key]');
        if (!item) return;
        const quantity = Number(item.querySelector('input').value) || 0;

        if (event.target.closest('[data-qty-minus]')) this.changeLine(item.dataset.lineKey, quantity - 1);
        if (event.target.closest('[data-qty-plus]')) this.changeLine(item.dataset.lineKey, quantity + 1);
        if (event.target.closest('[data-remove]')) this.changeLine(item.dataset.lineKey, 0);
      });

      this.itemsList.addEventListener('change', (event) => {
        const input = event.target.closest('input');
        const item = event.target.closest('[data-line-key]');
        if (!input || !item) return;
        this.changeLine(item.dataset.lineKey, Math.max(0, Number(input.value) || 0));
      });

      this.offer.addEventListener('change', (event) => {
        if (event.target.closest('[data-offer-option]')) this.updateOffer();
      });

      this.offer.addEventListener('click', (event) => {
        if (event.target.closest('[data-offer-prev]')) this.stepOffer(-1);
        if (event.target.closest('[data-offer-next]')) this.stepOffer(1);
        if (event.target.closest('[data-offer-add]')) this.addOfferVariant();
      });

      let touchX = null;
      this.offer.addEventListener('touchstart', (event) => {
        touchX = event.target.closest('select') ? null : event.touches[0].clientX;
      }, { passive: true });
      this.offer.addEventListener('touchend', (event) => {
        if (touchX === null) return;
        const delta = event.changedTouches[0].clientX - touchX;
        if (Math.abs(delta) > 40) this.stepOffer(delta < 0 ? 1 : -1);
        touchX = null;
      });

      this.protectionInput?.addEventListener('change', () => this.setProtection(this.protectionInput.checked));
    }

    /* Ook adds van andere apps (bijv. Kaching Bundles) openen de drawer, net als bij UpCart. */
    interceptAddToCart() {
      const drawer = this;
      const isAddUrl = (url) => /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || ''));

      const originalFetch = window.fetch;
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : input?.url;
        const request = originalFetch.apply(this, arguments);
        if (isAddUrl(url) && !init?.pmCartInternal) {
          request.then((response) => {
            if (response.ok) drawer.refresh().then(() => drawer.open());
          }).catch(() => {});
        }
        return request;
      };

      const originalOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (isAddUrl(url)) {
          this.addEventListener('load', () => {
            if (this.status >= 200 && this.status < 300) drawer.refresh().then(() => drawer.open());
          });
        }
        return originalOpen.apply(this, arguments);
      };
    }

    async handleProductForm(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-product-form]')) return;
      const submitter = event.submitter;
      if (!submitter || submitter.getAttribute('name') !== 'add') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const label = submitter.querySelector('[data-add-to-cart-label]');
      const labelText = label?.textContent;
      const errorNode = form.querySelector('[data-add-to-cart-error]');
      if (errorNode) errorNode.hidden = true;
      submitter.disabled = true;
      this.lastFocus = submitter;

      try {
        const response = await fetch(`${this.routeRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          pmCartInternal: true
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data?.description || data?.message || '');
        await this.refresh();
        this.open();
      } catch (error) {
        if (errorNode) {
          errorNode.textContent = error.message || errorNode.dataset.genericError || '';
          errorNode.hidden = false;
        } else {
          window.location.href = `${this.routeRoot}cart`;
        }
      } finally {
        submitter.disabled = false;
        if (label && labelText) label.textContent = labelText;
      }
    }

    /* ---------- Cart API ---------- */

    async refresh() {
      const response = await fetch(`${this.routeRoot}cart.js`, { headers: { Accept: 'application/json' }, pmCartInternal: true });
      const cart = await response.json();
      if (await this.cleanOrphanProtection(cart)) return this.refresh();
      await this.loadMissingCompareAt(cart);
      this.render(cart);
      return cart;
    }

    async changeLine(key, quantity) {
      if (this.pending.has(key)) return;
      this.pending.add(key);
      this.itemsList.querySelector(`[data-line-key="${CSS.escape(key)}"]`)?.classList.add('is-pending');

      try {
        const response = await fetch(`${this.routeRoot}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
          pmCartInternal: true
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart?.description || '');
        this.pending.delete(key);
        if (await this.cleanOrphanProtection(cart)) {
          await this.refresh();
          return;
        }
        await this.loadMissingCompareAt(cart);
        this.render(cart);
      } catch (error) {
        console.error(error);
        this.pending.delete(key);
        await this.refresh();
      }
    }

    /* Verzekering zonder producten heeft geen zin: dan halen we hem weg. */
    async cleanOrphanProtection(cart) {
      const protection = (cart.items || []).find((item) => this.isProtection(item));
      if (!protection) return false;
      const needsRemoval = this.productItems(cart).length === 0;
      const needsFix = !needsRemoval && protection.quantity !== 1;
      if (!needsRemoval && !needsFix) return false;

      await fetch(`${this.routeRoot}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: protection.key, quantity: needsRemoval ? 0 : 1 }),
        pmCartInternal: true
      });
      return true;
    }

    async setProtection(enabled) {
      if (this.busy || !this.protectionId) return;
      this.busy = true;
      this.protection.classList.add('is-pending');

      try {
        const current = (this.cart?.items || []).find((item) => this.isProtection(item));
        if (enabled && !current) {
          await fetch(`${this.routeRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: this.protectionId, quantity: 1 }] }),
            pmCartInternal: true
          });
        } else if (!enabled && current) {
          await fetch(`${this.routeRoot}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: current.key, quantity: 0 }),
            pmCartInternal: true
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.busy = false;
        this.protection.classList.remove('is-pending');
        await this.refresh();
      }
    }

    async fetchProduct(handle) {
      if (!this.productCache.has(handle)) {
        this.productCache.set(
          handle,
          fetch(`${this.routeRoot}products/${handle}.js`, { pmCartInternal: true })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        );
      }
      return this.productCache.get(handle);
    }

    async loadMissingCompareAt(cart) {
      const missing = this.productItems(cart).filter((item) => !this.compareAt.has(item.variant_id));
      await Promise.all(
        missing.map(async (item) => {
          const product = await this.fetchProduct(item.handle);
          const variant = product?.variants?.find((v) => v.id === item.variant_id);
          this.compareAt.set(item.variant_id, Number(variant?.compare_at_price || 0));
        })
      );
    }

    /* ---------- Render ---------- */

    render(cart) {
      this.cart = cart;
      const items = this.productItems(cart);
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      const hasProtection = (cart.items || []).some((item) => this.isProtection(item));

      this.title.textContent = this.text.title.replace('[count]', count);
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = count;
        node.hidden = count === 0;
      });

      this.empty.hidden = count > 0;
      this.footer.hidden = count === 0;
      this.itemsList.innerHTML = items.map((item) => this.lineMarkup(item)).join('');
      if (this.protectionInput) this.protectionInput.checked = hasProtection;
      this.renderOffer(cart, items, count);
      this.renderDiscounts(cart);
      this.renderTimer();
    }

    lineMarkup(item) {
      const compareUnit = this.compareAt.get(item.variant_id) || 0;
      const compareLine = compareUnit * item.quantity;
      // Prijs vóór staffelkorting; de korting zelf staat in de regel "Sconti" (zoals bij UpCart).
      const linePrice = item.original_line_price;
      const showCompare = compareLine > linePrice;
      const variantText = (item.options_with_values || [])
        .filter((option) => option.value !== 'Default Title')
        .map((option) => `${this.escape(option.name)}: ${this.escape(option.value)}`)
        .join(', ');
      const image = item.image ? this.resizeImage(item.image, 200) : '';
      const pending = this.pending.has(item.key);

      return `
        <li class="pm-cart__item${pending ? ' is-pending' : ''}" data-line-key="${this.escape(item.key)}">
          <a class="pm-cart__item-media" href="${this.escape(item.url)}">
            ${image ? `<img src="${this.escape(image)}" alt="${this.escape(item.product_title)}" width="88" height="88" loading="lazy">` : ''}
          </a>
          <div class="pm-cart__item-info">
            <div class="pm-cart__item-header">
              <p class="pm-cart__item-title"><a href="${this.escape(item.url)}">${this.escape(item.product_title)}</a></p>
              <button type="button" class="pm-cart__remove" data-remove aria-label="${this.escape(this.text.remove)}: ${this.escape(item.product_title)}">${TRASH_ICON}</button>
            </div>
            ${variantText ? `<div class="pm-cart__item-variant">${variantText}</div>` : ''}
            <div class="pm-cart__item-pricing">
              ${showCompare ? `<span class="pm-cart__item-compare">${this.formatMoney(compareLine)}</span>` : ''}
              <span class="pm-cart__item-price">${this.formatMoney(linePrice)}</span>
            </div>
            <div class="pm-cart__quantity">
              <button type="button" data-qty-minus aria-label="${this.escape(this.text.decrease)}">&minus;</button>
              <input type="number" min="0" value="${item.quantity}" aria-label="${this.escape(this.text.quantity)}">
              <button type="button" data-qty-plus aria-label="${this.escape(this.text.increase)}">+</button>
            </div>
          </div>
        </li>`;
    }

    /* Aanbod: nog een van hetzelfde model (standaard) of een vergelijkbaar model uit dezelfde collectie,
       in een zelfgekozen kleur/maat. De korting komt uit de staffel. */
    async renderOffer(cart, items, count) {
      const token = (this.offerToken = (this.offerToken || 0) + 1);
      const tiers = this.config.tiers || [];
      // Alleen bij precies 1 artikel in de cart; vanaf het 2e artikel verdwijnt de kaart.
      const next = count === 1 ? tiers.find((tier) => tier.quantity === 2) : null;
      const item = items[0];
      const [product, similar] = item && next
        ? await Promise.all([this.fetchProduct(item.handle), this.fetchSimilar(item.handle, items)])
        : [null, []];
      if (token !== this.offerToken) return;

      const sameAvailable = (product?.variants || []).some((variant) => variant.available);
      if (!item || !next || (!sameAvailable && !similar.length)) {
        this.offerState = null;
        this.offerBase = null;
        this.offer.hidden = true;
        this.offer.innerHTML = '';
        return;
      }

      const sizeOption = (item.options_with_values || []).find((option) => SIZE_NAME.test(option.name));
      this.offerBase = {
        item,
        percent: next.percent,
        productSubtotal: items.reduce((sum, line) => sum + line.original_line_price, 0),
        currentDiscount: cart.total_discount || 0,
        isShoe: (item.options_with_values || []).some((option) => /scarp|numero/i.test(option.name) || SHOE_SIZE.test(String(option.value).trim())),
        size: sizeOption?.value || null
      };

      // Slider: eerst hetzelfde model, daarna vergelijkbare modellen.
      this.offerHandles = [sameAvailable ? item.handle : null, ...similar.map((p) => p.handle)].filter(Boolean);
      this.offerIndex = 0;
      const multiple = this.offerHandles.length > 1;

      this.offer.innerHTML = `
        <div class="pm-cart__offer-card">
          <span class="pm-cart__offer-badge">-${next.percent}% ${this.escape(this.text.offerOnAll)}</span>
          ${multiple ? `
            <div class="pm-cart__offer-nav">
              <button type="button" data-offer-prev aria-label="${this.escape(this.text.offerPrevious)}">
                <svg width="14" height="14" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M12 15l-5-5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <span data-offer-counter aria-live="polite"></span>
              <button type="button" data-offer-next aria-label="${this.escape(this.text.offerNext)}">
                <svg width="14" height="14" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M8 5l5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>` : ''}
          <div data-offer-content></div>
        </div>`;
      this.offer.hidden = false;
      await this.showOfferProduct(this.offerHandles[0]);
    }

    stepOffer(direction) {
      const handles = this.offerHandles || [];
      if (handles.length < 2) return;
      this.offerIndex = (this.offerIndex + direction + handles.length) % handles.length;
      this.showOfferProduct(handles[this.offerIndex], direction);
    }

    async showOfferProduct(handle, direction = 0) {
      const base = this.offerBase;
      if (!base) return;
      const showToken = (this.offerShowToken = (this.offerShowToken || 0) + 1);
      const product = await this.fetchProduct(handle);
      const available = (product?.variants || []).filter((variant) => variant.available);
      if (!product || !available.length || this.offerBase !== base || showToken !== this.offerShowToken) return;

      const isSame = handle === base.item.handle;
      let start = null;
      if (isSame) {
        start = product.variants.find((variant) => variant.id === base.item.variant_id && variant.available) || available[0];
      } else {
        // Zelfde maat als het product in de cart, als die leverbaar is.
        const sizeIndex = (product.options || []).findIndex((option) => SIZE_NAME.test(option.name));
        start = (base.size && sizeIndex >= 0 && available.find((variant) => this.sameSize(variant.options[sizeIndex], base.size))) || available[0];
      }

      const optionNames = (product.options || []).filter((option) => option.values.length > 1).map((option) => option.name.toLowerCase());
      const optionText = optionNames.join(` ${this.text.offerAnd} `);
      const title = isSame
        ? this.text.offerTitle.replace('[noun]', base.isShoe ? this.text.offerPair : this.text.offerPiece)
        : product.title;
      const subtitle = isSame
        ? (optionNames.length ? this.text.offerSubtitle.replace('[options]', optionText) : this.text.offerSubtitleSimple)
        : (optionNames.length ? this.text.offerSubtitleOther.replace('[options]', optionText) : this.text.offerSubtitleOtherSimple);

      const selects = (product.options || []).map((option, index) => {
        if (option.values.length < 2) return '';
        const values = option.values
          .map((value) => `<option value="${this.escape(value)}"${start.options[index] === value ? ' selected' : ''}>${this.escape(value)}</option>`)
          .join('');
        return `<select data-offer-option="${index}" aria-label="${this.escape(option.name)}">${values}</select>`;
      }).join('');

      this.offerState = {
        product,
        percent: base.percent,
        productSubtotal: base.productSubtotal,
        currentDiscount: base.currentDiscount
      };

      const content = this.offer.querySelector('[data-offer-content]');
      content.innerHTML = `
        <div class="pm-cart__offer-body">
          <a class="pm-cart__offer-media" href="${this.escape(product.url)}" data-offer-link tabindex="-1" aria-hidden="true">
            <img class="pm-cart__offer-image" data-offer-image alt="" width="64" height="64" loading="lazy">
          </a>
          <div class="pm-cart__offer-info">
            <p class="pm-cart__offer-title"><a href="${this.escape(product.url)}" data-offer-link>${this.escape(title)}</a></p>
            <p class="pm-cart__offer-variant">${this.escape(subtitle)}</p>
            <p class="pm-cart__offer-price" data-offer-price></p>
          </div>
        </div>
        <div class="pm-cart__offer-row">
          ${selects}
          <button type="button" class="pm-cart__offer-button" data-offer-add>${this.escape(this.text.offerButton)}</button>
        </div>`;

      const counter = this.offer.querySelector('[data-offer-counter]');
      if (counter) counter.textContent = `${this.offerIndex + 1}/${this.offerHandles.length}`;
      if (direction && content.animate) {
        content.animate(
          [{ opacity: 0, transform: `translateX(${direction * 24}px)` }, { opacity: 1, transform: 'none' }],
          { duration: 220, easing: 'ease-out' }
        );
      }
      this.updateOffer();
    }

    /* Vergelijkbare modellen: uit de meest specifieke collectie van het product (zie templates/product.pm-cart-data.liquid). */
    async fetchSimilar(handle, items) {
      if (!this.similarCache) this.similarCache = new Map();
      if (!this.similarCache.has(handle)) {
        this.similarCache.set(handle, (async () => {
          try {
            const data = await fetch(`${this.routeRoot}products/${handle}?view=pm-cart-data`, { pmCartInternal: true }).then((r) => r.json());
            if (!data?.collection) return [];
            const list = await fetch(`${this.routeRoot}collections/${data.collection}/products.json?limit=30`, { pmCartInternal: true }).then((r) => r.json());
            return (list.products || [])
              .filter((p) => p.variants.some((variant) => variant.available))
              .map((p) => ({ id: p.id, handle: p.handle, title: p.title, image: p.images?.[0]?.src || '' }));
          } catch (error) {
            return [];
          }
        })());
      }
      const inCart = new Set(items.map((line) => line.product_id));
      const list = await this.similarCache.get(handle);
      return list.filter((p) => p.handle !== handle && !inCart.has(p.id)).slice(0, this.config.similarCount || 3);
    }

    selectedOfferVariant() {
      const chosen = this.selectedOptionValues();
      return this.offerState.product.variants.find((variant) => variant.options.every((value, index) => value === chosen[index])) || null;
    }

    updateOffer() {
      if (!this.offerState) return;
      const { product, percent, productSubtotal, currentDiscount } = this.offerState;
      const variant = this.selectedOfferVariant();
      const button = this.offer.querySelector('[data-offer-add]');
      const priceNode = this.offer.querySelector('[data-offer-price]');
      const imageNode = this.offer.querySelector('[data-offer-image]');

      // Maten/kleuren die bij de huidige keuze niet leverbaar zijn, krijgen "(esaurito)".
      this.offer.querySelectorAll('[data-offer-option]').forEach((select) => {
        const index = Number(select.dataset.offerOption);
        [...select.options].forEach((option) => {
          const others = this.selectedOptionValues();
          others[index] = option.value;
          const match = product.variants.find((v) => v.options.every((value, i) => value === others[i]));
          option.textContent = match?.available ? option.value : `${option.value} (${this.text.offerSoldOut.toLowerCase()})`;
        });
      });

      const image = variant?.featured_image?.src || product.featured_image || '';
      if (imageNode) {
        imageNode.hidden = !image;
        if (image) imageNode.src = this.resizeImage(image, 160);
      }

      // Foto en naam linken naar de productpagina, in de gekozen kleur/maat.
      const href = variant ? `${product.url}?variant=${variant.id}` : product.url;
      this.offer.querySelectorAll('[data-offer-link]').forEach((link) => { link.href = href; });

      if (!variant || !variant.available) {
        priceNode.textContent = '';
        button.disabled = true;
        button.textContent = this.text.offerSoldOut;
        return;
      }

      // Prijs van dit artikel met de staffelkorting, plus wat de klant in totaal op de bestelling bespaart.
      const itemPrice = variant.price - Math.round((variant.price * percent) / 100);
      const orderSaving = Math.round(((productSubtotal + variant.price) * percent) / 100) - currentDiscount;
      priceNode.innerHTML = `
        <span class="pm-cart__offer-price-now">${this.formatMoney(itemPrice)}</span>
        <span class="pm-cart__offer-price-was">${this.formatMoney(variant.price)}</span>
        <span class="pm-cart__offer-saving">${this.escape(this.text.offerSaving.replace('[amount]', this.formatMoney(orderSaving)))}</span>`;
      button.disabled = false;
      button.textContent = this.text.offerButton;
      button.dataset.variantId = variant.id;
    }

    /* "EU 37", "37" en "37 EU" zijn dezelfde maat; bij kleding ("S", "M") gewoon tekstvergelijking. */
    sameSize(a, b) {
      const normalize = (value) => {
        const text = String(value || '').trim().toLowerCase();
        const number = text.match(/\d+([.,]\d+)?/);
        return number ? number[0].replace(',', '.') : text;
      };
      return normalize(a) === normalize(b);
    }

    selectedOptionValues() {
      const { product } = this.offerState;
      return (product.options || []).map((option, index) => {
        const select = this.offer.querySelector(`[data-offer-option="${index}"]`);
        return select ? select.value : option.values[0];
      });
    }

    async addOfferVariant() {
      const button = this.offer.querySelector('[data-offer-add]');
      const variantId = Number(button?.dataset.variantId || 0);
      if (!variantId || button.disabled) return;
      button.disabled = true;

      try {
        const response = await fetch(`${this.routeRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          pmCartInternal: true
        });
        if (!response.ok) throw new Error('add failed');
      } catch (error) {
        console.error(error);
      } finally {
        await this.refresh();
      }
    }

    renderDiscounts(cart) {
      const total = cart.total_discount || 0;
      const titles = new Set();
      (cart.cart_level_discount_applications || []).forEach((d) => d.title && titles.add(d.title));
      (cart.items || []).forEach((item) =>
        (item.line_level_discount_allocations || []).forEach((a) => a.discount_application?.title && titles.add(a.discount_application.title))
      );

      this.summary.hidden = total <= 0;
      if (total <= 0) return;

      this.discountTags.innerHTML = [...titles]
        .map((title) => `<span class="pm-cart__tag">${TAG_ICON}<span>${this.escape(title)}</span></span>`)
        .join('');
      this.discountTotal.textContent = `- ${this.formatMoney(total)}`;
    }

    /* ---------- Timer ---------- */

    startTimer() {
      let start = null;
      try {
        start = Number(sessionStorage.getItem(TIMER_KEY));
        if (!start) {
          start = Date.now();
          sessionStorage.setItem(TIMER_KEY, String(start));
        }
      } catch (error) {
        start = Date.now();
      }
      this.timerStart = start;
      this.timerInterval = setInterval(() => this.renderTimer(), 1000);
    }

    renderTimer() {
      const remaining = Math.ceil(this.config.timerSeconds - (Date.now() - this.timerStart) / 1000);
      const hasItems = this.cart ? this.productItems(this.cart).length > 0 : false;

      if (remaining <= 0) {
        this.timer.hidden = true;
        clearInterval(this.timerInterval);
        return;
      }

      this.timer.hidden = !hasItems;
      const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      this.timer.querySelector('p').textContent = this.text.timer.replace('[timer]', `${minutes}:${seconds}`);
    }

    /* ---------- Open / sluiten ---------- */

    isOpen() {
      return this.root.classList.contains('is-open');
    }

    open() {
      if (this.isOpen()) return;
      this.lastFocus = this.lastFocus || document.activeElement;
      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pm-cart-open');
      document.querySelectorAll('[data-cart-toggle]').forEach((node) => node.setAttribute('aria-expanded', 'true'));
      this.title.focus({ preventScroll: true });
    }

    close() {
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pm-cart-open');
      document.querySelectorAll('[data-cart-toggle]').forEach((node) => node.setAttribute('aria-expanded', 'false'));
      this.lastFocus?.focus?.({ preventScroll: true });
      this.lastFocus = null;
    }

    trapFocus(event) {
      const nodes = [...this.panel.querySelectorAll('a[href], button:not(:disabled), input, select, [tabindex]:not([tabindex="-1"])')]
        .filter((node) => node.offsetParent !== null);
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ---------- Helpers ---------- */

    formatMoney(cents) {
      const format = this.config.moneyFormat || '€{{amount_with_comma_separator}}';
      const value = (Number(cents) || 0) / 100;
      const withSeparators = (decimals, thousands, decimal) => {
        const [whole, fraction] = value.toFixed(decimals).split('.');
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return fraction ? `${grouped}${decimal}${fraction}` : grouped;
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals': return withSeparators(0, ',', '.');
          case 'amount_with_comma_separator': return withSeparators(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withSeparators(0, '.', ',');
          case 'amount_with_apostrophe_separator': return withSeparators(2, "'", '.');
          default: return withSeparators(2, ',', '.');
        }
      });
    }

    resizeImage(src, width) {
      if (!src) return '';
      const url = src.startsWith('//') ? `https:${src}` : src;
      return url.includes('?') ? `${url}&width=${width}` : `${url}?width=${width}`;
    }

    escape(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
    }
  }

  const init = () => {
    const root = document.querySelector('[data-pm-cart]');
    if (root && !root.pmCart) root.pmCart = new PmCartDrawer(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
